import { IUserProfilesSummary } from 'interfaces/users'

import api from '..'

export type LmsProfileResourceType =
  | 'user'
  | 'user_workspace'
  | 'course'
  | 'learning_path'

/** Filtro de asociación curso↔perfil (`courses_lms_profiles.kind`). */
export type LmsProfileCourseKind = 'required' | 'optional'

interface GetProfilesOptinalParams {
  page: number
  search: string
  perPage?: number
  /** Solo aplica con `resource.type === 'course'`. */
  kind?: LmsProfileCourseKind
}

export const getProfilesByResource = (
  resource: {
    id: number | string
    type: LmsProfileResourceType
  },
  { page, search, perPage, kind }: GetProfilesOptinalParams
): Promise<{ data: IUserProfilesSummary }> => {
  return api.get(`/administration/lms_profiles/search`, {
    params: {
      resource_type: resource.type,
      resource_id: resource.id,
      search,
      page,
      per_page: perPage,
      ...(kind ? { kind } : {}),
    },
  })
}
